module.exports = __webpack_public_path__ + "004ee55d0e5e398b3c48c2590eef35ba.pdf";